import { render } from "./WCDesktopHeaderV2.vue?vue&type=template&id=d5466e32&scoped=true"
import script from "./WCDesktopHeaderV2.vue?vue&type=script&lang=js"
export * from "./WCDesktopHeaderV2.vue?vue&type=script&lang=js"

import "./WCDesktopHeaderV2.vue?vue&type=style&index=0&id=d5466e32&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5466e32"]])

export default __exports__